import React from 'react';
import EntityDeleteError from '../../components/UI/EntityDeleteError';

/**
 * Customer-specific wrapper for EntityDeleteError
 * Maintains backwards compatibility with existing code
 * 
 * @deprecated Consider using EntityDeleteError directly for new code
 */
const CustomerDeleteError = ({ error, onRetry }) => {
  return (
    <EntityDeleteError
      error={error}
      onRetry={onRetry}
      entityType="Customer"
      entityName="customer"
      relatedEntities={[
        { type: 'Lead', path: '/leads', labelKey: 'nav.leads', resolveKey: 'customers.resolveLeads' },
        { type: 'Opportunity', path: '/opportunities', labelKey: 'nav.opportunities', resolveKey: 'customers.resolveOpportunities' },
        { type: 'Contract', path: '/contracts', labelKey: 'nav.contracts', resolveKey: 'customers.resolveContracts' },
        { type: 'Invoice', path: '/invoices', labelKey: 'nav.invoices', resolveKey: 'customers.resolveInvoices' }
      ]}
      translations={{
        cannotDelete: 'customers.cannotDeleteCustomer',
        dependenciesFound: 'customers.dependenciesFound',
        dependenciesExplanation: 'customers.dependenciesExplanation',
        howToResolve: 'customers.howToResolve',
        retryAfterResolving: 'customers.retryAfterResolving'
      }}
      errorPattern="Cannot delete customer"
    />
  );
};

export default CustomerDeleteError;
